import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

class PagePagination extends Component {
    _handlePageChange = (data) => {
        const {selected} = data

        this.props.onChangePage(selected + 1)
    }

    render() {
        const {pages, page} = this.props

        if (pages <= 1) return null

        return (
            <div className='PagePagination Pagination'>
                <ReactPaginate
                    previousLabel="Previous"
                    nextLabel="Next"
                    pageCount={pages}
                    forcePage={page - 1}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this._handlePageChange}
                    containerClassName="pagination"
                    pageClassName='page-item'
                    previousClassName='Previous page-item'
                    nextClassName='Next page-item'
                    pageLinkClassName='page-link'
                    previousLinkClassName='page-link'
                    nextLinkClassName='page-link'
                    subContainerClassName="pages pagination"
                    activeClassName='active'
                />
            </div>
        )
    }
}

PagePagination.propTypes = {
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
}

export default PagePagination
